
export default {
    name: 'ServicesHeader',
    props: {
        headerImage: {
            type: String,
            required: true,
        },
        headerImageAlt: {
            type: String,
            default: '',
        },
        service: {
            type: Number,
            default: null,
        },
        text: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    mounted() {
        if (this.$store.state.auth.loggedIn && this.service) {
            this.$router.replace({ name: 'waste-removal', query: { service: this.service } });
        }
    },
    methods: {
        redirect() {
            this.$router.push({ name: 'waste-removal', query: { service: this.service } });
        },
        scrollTo(id) {
            document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
        },
    },
};
